// extracted by mini-css-extract-plugin
export default {"wrapper":"mAZF70It--BusyLoader_wrapper__VOhQw","wrapper--ie11":"mAZF70It--BusyLoader_wrapper--ie11__Lb9Mw","wrapperIe11":"mAZF70It--BusyLoader_wrapper--ie11__Lb9Mw"};